import type {
	TTFBDistributionQuery,
	TTFDDistributionQuery,
	CohortRetentionQuery,
	StickinessQuery,
	PlayerLifecycleQuery,
} from './api/services'

export const QUERY_KEYS = {
	RETENTION_ANALYTICS: {
		ALL: ['retention-analytics'] as const,
		TTFB: (query: TTFBDistributionQuery | undefined) =>
			[...QUERY_KEYS.RETENTION_ANALYTICS.ALL, 'TTFB', query] as const,
		TTFD: (query: TTFDDistributionQuery | undefined) =>
			[...QUERY_KEYS.RETENTION_ANALYTICS.ALL, 'ttfd', query] as const,
		COHORT: (query: CohortRetentionQuery | undefined) =>
			[...QUERY_KEYS.RETENTION_ANALYTICS.ALL, 'cohort', query] as const,
		STICKINESS: (query: StickinessQuery | undefined) =>
			[...QUERY_KEYS.RETENTION_ANALYTICS.ALL, 'stickiness', query] as const,
		LIFECYCLE: (query: PlayerLifecycleQuery | undefined) =>
			[...QUERY_KEYS.RETENTION_ANALYTICS.ALL, 'lifecycle', query] as const,
	},
}

export const BUCKET_SIZE_OPTIONS = [
	{ value: 'minute', label: 'นาที' },
	{ value: 'hour', label: 'ชั่วโมง' },
	{ value: 'day', label: 'วัน' },
]

export const COHORT_TYPE_OPTIONS = [
	{ value: 'daily', label: 'รายวัน' },
	{ value: 'weekly', label: 'รายสัปดาห์' },
	{ value: 'monthly', label: 'รายเดือน' },
]

export const WINDOW_TYPE_OPTIONS = [
	{ value: 'daily', label: 'รายวัน' },
	{ value: 'weekly', label: 'รายสัปดาห์' },
	{ value: 'monthly', label: 'รายเดือน' },
]

export const RETENTION_DAYS_OPTIONS = [
	{ value: 7, label: '7 วัน' },
	{ value: 14, label: '14 วัน' },
	{ value: 30, label: '30 วัน' },
	{ value: 60, label: '60 วัน' },
	{ value: 90, label: '90 วัน' },
]
